import React, { useEffect, useState, useCallback } from "react"
import { ErrorBoundary } from "../ErrorBoundary"
import { qs, FilterBar, RawTable } from "./components"

// Traffic → Reports (doc 11): row-level GA4 facts with the shared filter bar +
// pagination. Its own page (no tabs); links back to the overview.
export default function TrafficReportsApp({ trafficPath, overviewPath, copy }) {
  const [options, setOptions] = useState({ apps: [], countries: [], referrers: [] })
  const [draft, setDraft] = useState({})
  const [applied, setApplied] = useState({})

  // Pull the overview aggregates once just to populate the filter dropdowns.
  const loadOptions = useCallback(() => {
    fetch(trafficPath, { headers: { Accept: "application/json" } })
      .then((r) => r.json())
      .then((d) =>
        setOptions({
          apps: (d.byApp || []).map((r) => r.label),
          countries: (d.byCountry || []).map((r) => r.label),
          referrers: (d.byReferrer || []).map((r) => r.label),
        })
      )
  }, [trafficPath])

  useEffect(() => { loadOptions() }, [loadOptions])

  const rowsPath = `${trafficPath}${trafficPath.includes("?") ? "" : "?"}`

  return (
    <ErrorBoundary>
      <div className="space-y-6">
        <div>
          <a href={overviewPath} className="text-sm font-medium text-brand-600 dark:text-brand-400 hover:text-brand-700">← {copy.back}</a>
          <h1 className="mt-1 text-2xl font-bold text-gray-900 dark:text-gray-100">{copy.title}</h1>
        </div>
        <FilterBar
          draft={draft}
          setDraft={setDraft}
          options={options}
          onApply={() => setApplied(draft)}
          onClear={() => { setDraft({}); setApplied({}) }}
          copy={copy.filters}
        />
        <RawTable rowsPath={rowsPath} filters={applied} copy={copy.raw} />
      </div>
    </ErrorBoundary>
  )
}
